import { React, useEffect, useState, useRef } from "react";
import styles from "../home/home.module.scss";

import Navbar from "../../components/navbar/Navbar";
import HeroSectionPage from "../heroSection/HeroSectionPage";
import HoverContent from "../../components/hoverContent/HoverContent";
import RecentBlogPage from "../recentBlogPage/RecentBlogPage";
import Ourservice from "../ourService/OurService";
import ServerMegamPage from "../serverMegamPage/ServerMegamPage";
import AboutUs from "../../components/about/AboutUs";
import Contact from "../../components/contact/Contact";
import Footer from "../footer/Footer";
import ServiceOptimisation from "../../components/serviceOptimisation/ServiceOptimisation";
import ServicesCard from "../../components/servicesCard/ServicesCard";
import StepIntoKriha from "../../components/stepIntoKriha/StepIntoKriha";
import SplashScreen from "../../pages/splashScreen/SplashScreen";
import CardStack from "../../components/cardStack/CardStack";
import { useLocation } from "react-router-dom";

const Home = () => {
  const [showSplash, setShowSplash] = useState(false);
  const [revealHover, setRevealHover] = useState(false);
  const serviceRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShowSplash(true);
          setRevealHover(false);
          setTimeout(() => {
            setShowSplash(false);
            setRevealHover(true);
          }, 1000);
        }
      },
      { threshold: 0.5 }
    );

    if (serviceRef.current) observer.observe(serviceRef.current);

    return () => {
      if (serviceRef.current) observer.unobserve(serviceRef.current);
    };
  }, []);

  useEffect(() => {
    const section = document.getElementById("hero");
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, []);

  useEffect(() => {
    if (location.state?.scrollTo) {
      const section = document.getElementById(location.state.scrollTo);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  return (
    <div className={styles.container}>
      <Navbar />
      <HeroSectionPage id="hero" />

      {showSplash && <SplashScreen />}

      <div
        ref={serviceRef}
        className={`${styles.animatedSection} ${
          revealHover ? styles.reveal : ""
        }`}
      >
        <HoverContent />
      </div>

      <Ourservice id='ourServices'/>
      <CardStack />
      <ServiceOptimisation />
      <StepIntoKriha />
      <AboutUs id="about" />
      <RecentBlogPage />
      <Contact id="contact" />
      <ServerMegamPage />
      <Footer />
    </div>
  );
};

export default Home;
